import * as React from 'react';
import { ILocationsGroup } from '../../types';
import * as styles from './LocationPickerGroup.css';
import { LocationPickerLink } from '../LocationPickerLink';

interface ILocationPickerGroupProps extends ILocationsGroup {
  onLinkClick(locationId: number): void;
}

export const LocationPickerGroup: React.FC<ILocationPickerGroupProps> = ({ title, locations, onLinkClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{title}</div>
      <div>
        {locations.map(location => (
          <div key={location.id} className={styles['item']}>
            <LocationPickerLink size="small" onClick={() => onLinkClick(location.id)}>
              {location.name}
            </LocationPickerLink>
          </div>
        ))}
      </div>
    </div>
  );
};
